<template>
  <div>
    <el-row>
      <el-col :span="8" :offset="8">
        <p style="text-align: center">
          <span class="systemFont1">{{$t('courseOption.courseInquiry')}}</span>
        </p>
      </el-col>
      <el-col :span="3" :offset="2">
        <!-- s手机浏览选课链接按钮 -->
        <el-button
          type="text"
          style="float: right;margin:17.5px 0"
          @click="linkVisible=true">{{ $t("courseOption.courseLinkPhone") }}
        </el-button>
      </el-col>
      <el-col :span="2" :offset="1">
        <!-- 下载二维码链接 -->
         <el-button
          type="text"
          style="float: left;margin:17.5px 0"
          @click="downloadQrCode()">{{ $t("courseOption.createQrCode") }}
        </el-button>
      </el-col>
    </el-row>
    <el-row style="top: 17px">
      <!-- 模糊查询 -->
      <div style="display: inline-block;">
        <el-form
          @submit.native.prevent="init()"
          :model="queryForm"
          label-position="right"
          label-width="80px"
          class="systemFont1"
        >
          <div style="width:400px;display: inline-block; float:left;">
            <el-form-item
              :label="$t('courseOption.field')+' / '+$t('courseOption.category')"
              prop="selectRegion">
              <!--            <el-input v-model="baseCourse.selectRegion" :placeholder="'* ' + $t('registrationFree.selectRegion')"></el-input>-->
              <el-cascader
                clearable
                style="width: 320px;"
                v-model="selectRegion"
                :options="selectOption"
                @change="selectRegionChange"></el-cascader>
            </el-form-item>
          </div>

          <div style="width:40px;display:inline-block; float:left;">
            &nbsp;&nbsp;
          </div>
          <!-- 课程名称 -->
          <div style="width:400px;display: inline-block; float:left;">
            <el-form-item :label="$t('p0331.courseTitle')">
              <el-input
                name="queryForm.courseName"
                type="text"
                v-model="queryForm.courseName"
                clearable
                :placeholder="$t('p0331.courseTitle')"
              ></el-input>
            </el-form-item>
          </div>
          <div style="width:40px;display:inline-block; float:left;">
            &nbsp;&nbsp;
          </div>
          <div
            style="width:70px;height:100%;display: inline-block; float:left;"
          >
            <img
              src="../../assets/query2.svg"
              width="36px"
              height="36px"
              style="cursor: pointer;"
              @click="init(true)"
            />
          </div>
        </el-form>
      </div>
      <el-col :span="22" :offset="1">
        <el-table
          :data="courseData"
          style="width: 100%; margin-bottom: 75px">
          <el-table-column
            prop="field"
            :label="$t('courseOption.field')"
            align="left"
            min-width="52">
          </el-table-column>
          <el-table-column
            prop="category"
            :label="$t('courseOption.category')"
            align="left"
            min-width="86">
          </el-table-column>
          <el-table-column
            prop="viewNumber"
            :label="$t('courseOption.number')"
            align="left"
            min-width="52">
          </el-table-column>
          <!-- 默认形式 -->
          <el-table-column
            prop="form"
            :label="$t('courseOption.defaultForm')"
            align="center"
            width="90"
          >
          </el-table-column>
          <el-table-column
            prop="courseName"
            :label="$t('courseOption.courseName')"
            align="left"
            min-width="224">
          </el-table-column>
          <!-- 状态 -->
          <el-table-column
            prop="status"
            :label="$t('p0322.state')"
            align="center"
            width="80">
            <template slot-scope="scope">
              <span :style="scope.row.status === '1'?'color:red':''">{{scope.row.status === '1'?'停课':'正常'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('common.operation')"
            align="center"
            min-width="120">
            <template slot-scope="scope">
              <!-- 课程详细按钮 -->
              <el-button
                size="mini"
                type="text"
                @click="enterCourseDetails(scope.row)"
                  >&nbsp;{{ $t("courseOption.courseDetails") }}</el-button
              >
              <!-- 恢复 -->
              <el-button
                v-if="scope.row.status === '1'"
                size="mini"
                type="text"
                @click="updateStatus(scope.row,0)"
              >&nbsp;{{ $t("p0322.restore") }}
              </el-button
              >
              <!-- 停课 -->
              <el-button
                v-else
                size="mini"
                type="text"
                @click="updateStatus(scope.row,1)"
              >&nbsp;{{ $t("p0322.suspended") }}
              </el-button
              >

              <el-button v-if="scope.row.status !== '1'" @click="downloadCourseQR(scope.row)" type="text" size="mini">{{$t('courseOption.courseQRCode')}}</el-button>
            </template>
            <span>-</span>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-row style="text-align: right; margin: 20px">
          <el-col :span="24">
            <div class="block">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPageCo"
                :page-sizes="[10, 20, 50]"
                :page-size="pageSizeCo"
                layout="total, sizes, prev, pager, next"
                :total="totalCo"
              >
              </el-pagination>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-dialog
      :visible.sync="linkVisible"
      :title="$t('courseOption.courseLinkPhone')"
      width="550px"
    >
      <span style="text-align: center">{{browseLinkPhone}}</span>
    </el-dialog>
  </div>
</template>

<script>

  export default {
    data() {
      return {
        // 查询条件
        queryForm: {
          courseName: "",
          field: '',
          category: '',
        },
        // 当前页
        currentPageCo: 1,
        // 每页件数
        pageSizeCo: 10,
        totalCo: 0,
        // 课程数据
        courseData: [],
        // 弹框是否打开
        linkVisible: false,
        // 手机浏览选课链接
        browseLinkPhone: "",
        // 级联列表数据
        initSelectOption: [],
        // 组装后的级联列表
        selectOption: [],
        // 选择的领域类别key[ 领域, 类别 ]
        selectRegion: [],
      }
    },
    watch: {
      // 监听课程名称是否为空
      "queryForm.courseName"(newVal) {
        if (newVal === "") {
          this.queryForm.courseName = "";
          this.init(true);
        }
      },
      "queryForm.field"(newVal) {
        console.log('fieldvalue: ', newVal)
        if (newVal === "") {
          this.queryForm.field = "";
          this.init(true);
        }
      },
      "queryForm.category"(newVal) {
        console.log('categoryvalue: ', newVal)
        if (newVal === "") {
          this.queryForm.category = "";
          this.init(true);
        }
      }
    },
    methods: {
      // 初始化课程数据
      init(val=false) {
        if (val) {
          // 分页数据初始化
          this.currentPageCo = 1;
        }
        // if (val) {
        //   // 分页数据初始化
        //   this.currentPageCo = 1;
        //   this.totalCo = 0;
        // }
        const loading = this.$loading({
          lock: true,
          text: this.$t('common.loading'),
          background: "rgba(255,255,255,0.8)",
          target: document.querySelector("#main-container"),
        });
        let url = "/api/courseOption/initCourse"
        this.$http
          .post(url,{
            //课程名称模糊查询
            selectCourseName: this.queryForm.courseName,
            // 当前页
            currentSizeCo: (this.currentPageCo - 1) * this.pageSizeCo,
            // 页数
            pageSizeCo: this.pageSizeCo,
            // 总数
            // totalCo: this.totalCo
            field: this.queryForm.field,
            category: this.queryForm.category,
          })
          .then((response) => {
            if (response.data.code === 200) {
              // 总数取值
              this.totalCo = response.data.data.total;
              // 渲染页面
              this.courseData = response.data.data.records;
              // 手机链接
              this.browseLinkPhone=response.data.data.browseLinkPhone;
              // console.log("response.data.data",response.data.data)
              loading.close()
            } else {
              loading.close()
              this.$message.error(response.data.message)
            }
          })
          .catch((err) => {
            console.log(err)
            loading.close()
            this.$message.error(this.$t('common.anErrorOccurred'))
          });
      },
      updateStatus(row, status) {
        this.$confirm(status === 1?this.$t('p0322.msg1'):this.$t('p0322.msg2'))
          .then(rep => {
            const loading = this.$loading({
              lock: true,
              text: this.$t('common.loading'),
              background: "rgba(255,255,255,0.8)",
              target: document.querySelector("#main-container"),
            });

            let url = "/api/courseOption/updateStatus"
            this.$http
              .post(url, {
                ...row,
                status: status
              }).then((response) => {
              this.init()
              this.$message.seccess(this.$t("p0433.operationSuccess"))
            }).catch(err => {
              this.$message.error(err.data.message);
            }).finally(()=>[
              loading.close()
            ])
          })
          .catch(err => {
          });
      },
      // 进入课程详情
      enterCourseDetails(row) {
        console.log(row);
        let p0303 = JSON.stringify({
          field: row.field,
          category: row.category,
          courseNumber: row.courseNumber,
        });
        sessionStorage.p0303 = p0303;
        this.$router.push({
          path: "/views/GreenJacketForum/P0303",
          query: {
            courseName: this.queryForm.courseName,
            field: this.queryForm.field,
            category: this.queryForm.category,
            currentPageCo: this.currentPageCo,
            totalCo: this.totalCo,
            pageSizeCo: this.pageSizeCo
        }});
      },
      // 每页数据条数设定
      handleSizeChange(val) {
        this.pageSizeCo = val;
        this.currentPageCo = 1;
        //判断更改页码是否需要查询
        if (this.courseData == undefined || this.courseData.length <= 0) {
          return;
        }
        this.init(false);
        // console.log(`每页 ${val} 条`);
      },
      // 当前页显示
      handleCurrentChange(val) {
        this.currentPageCo = val;
        this.init(false);
        // console.log(`当前页: ${val}`);
      },
      // 下载二维码
      downloadQrCode(){
        const loading = this.$loading({
          lock: true,
          text: this.$t('common.loading'),
          background: "rgba(255,255,255,0.8)",
          target: document.querySelector("#main-container"),
        });

        let url = "/api/courseOption/getBrowseCourseQr"
        this.$http
          .post(url, {
            // 报名链接
            browseLinkPhone: this.browseLinkPhone,
          },{
            responseType: 'blob'
            }
          )
          .then((response) => {
            loading.close()
            // 文件名
            const fileName = this.$t("courseOption.browseCourseQRPhone")+".jpg";
            const fileStream = response.data; // 返回文件流
            const blob = new Blob([fileStream],)
            // 使用dom a 下载图片
            const a = document.createElement('a');
            const href = window.URL.createObjectURL(blob); // 创建下载连接
            a.href = href;
            a.download = fileName
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a); // 下载完移除元素
            window.URL.revokeObjectURL(href); // 释放掉blob对象
          })
          .catch((err) => {
            console.log(err)
            loading.close()
            this.$message.error(this.$t('common.anErrorOccurred'))
          });
      },
      downloadCourseQR(row){
        const loading = this.$loading({
          lock: true,
          text: this.$t('common.loading'),
          background: "rgba(255,255,255,0.8)",
          target: document.querySelector("#main-container"),
        });
        let url = "/api/courseOption/downloadCourseQR"
        this.$http
          .post(url, {
            // 报名链接
            courseQRLink: row.courseQRLink,
          },{
            responseType: 'blob'
            }
          )
          .then((response) => {
            loading.close()
            // 文件名
            // const fileName = this.$t("courseOption.courseQRCode")+".jpg";
            const fileName = row.courseName+row.viewNumber+".jpg";
            const fileStream = response.data; // 返回文件流
            const blob = new Blob([fileStream],)
            // 使用dom a 下载图片
            const a = document.createElement('a');
            const href = window.URL.createObjectURL(blob); // 创建下载连接
            a.href = href;
            a.download = fileName
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a); // 下载完移除元素
            window.URL.revokeObjectURL(href); // 释放掉blob对象
          })
          .catch((err) => {
            console.log(err)
            loading.close()
            this.$message.error(this.$t('common.anErrorOccurred'))
          });
      },
      initSelect(){
          let url = "/api/courseOption/initSelect";
          this.$http
            .post(url)
            .then(response => {
              if (response.data.code === 200) {
                this.initSelectOption = response.data.data
                // this.selection = data;
                // this.newForm.form = "01";
                // this.newForm.classLanguage = "001";
                let categories=[]

                for(let i=0;i<this.initSelectOption.length;i++){
                  let fieldElement = this.initSelectOption[i]
                  if(fieldElement.searchKey == 'field'){
                    // 获取类别
                    let categoryData = this.getCategoryData(fieldElement.codeKey)
                    let option = this.data2Option(fieldElement)
                    option.children = categoryData
                    this.selectOption.push(option)
                  }
                }

              } else {
                this.$message.error(response.data.message);
              }
            })
            .catch(err => {
              console.log(err);
              this.$message.error(this.$t("common.anErrorOccurred"));
            });
      },
      // 获取类别列表
      getCategoryData(val) {
        let categories=[]
        for(let i=0;i<this.initSelectOption.length;i++){
          let categoryElement = this.initSelectOption[i]
          if(val === categoryElement.fatherCodeKey && categoryElement.searchKey == 'category'){
            // 获取区
            let option = this.data2Option(categoryElement)
            categories.push(option)
          }
        }
        return categories
      },
      data2Option(item) {
        return {value: item.codeKey,label: item.codeKey+ ' ' + item.codeValueZh}
      },
      selectRegionChange(){
        console.log(this.selectRegion)
        if (this.selectRegion.length > 0) {
          this.queryForm.field = this.selectRegion[0]
        } else {
          this.queryForm.field = ''
        }
        if (this.selectRegion.length > 1) {
          this.queryForm.category = this.selectRegion[1]
        } else {
          this.queryForm.category = ''
        }
      },
    },
    mounted() {
      if (this.$route.query.currentPageCo) {
        this.currentPageCo = Number(this.$route.query.currentPageCo);
        console.log(1)
      }
      if (this.$route.query.totalCo) {
        this.totalCo = Number(this.$route.query.totalCo);
        console.log(2)
      }
      if (this.$route.query.pageSizeCo) {
        this.pageSizeCo = Number(this.$route.query.pageSizeCo);
        console.log(3)
      }
      if (this.$route.query.courseName) {
        this.queryForm.courseName = this.$route.query.courseName;
        console.log(4)
      }
      if (this.$route.query.field) {
        this.queryForm.field = this.$route.query.field;
        this.selectRegion.push(this.queryForm.field)
        console.log(5)
      }
      if (this.$route.query.category) {
        this.queryForm.category = this.$route.query.category;
        this.selectRegion.push(this.queryForm.category)
        console.log(6)
      }
      let path = this.$route.path; //先获取路由路径
      this.$router.replace(path); //再跳转路由路径，query参数没带过去，所以被清除了
      this.initSelect()
      this.init();
    }

  }
</script>

<style lang="scss" scoped>

>>>.el-table thead{
  font-family: 'Arial Negreta', 'Arial Normal', 'Arial';
  color: #333333;
  font-size: 16px;
}

>>>.el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170)
}

>>>.el-table__row {
  height: 42px;
}

>>>.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
  border-bottom: 0.5px solid rgb(170, 170, 170);
}

>>>.el-table--border::after, .el-table--group::after, .el-table::before{
  background: none;
}
>>>.el-dialog__body{
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/GreenJacketForum/P0302.vue